var Aneox;
(function(Aneox) {
    (function(Controllers) {
        'use strict';

        var Producers = (function() {

            var self;
            var currentProducerId;
            var producerListsFilter;

            function Producers(animations, locale, router) {
                self = this;
                self.timeline = animations.timeline;
                self.router = router;
                self.geographyData;
                self.producersData;
                self.letterData;
                
                
            }

            Producers.prototype.enter = function(producerId) {
                
               
                $('#producers-list-menu .show-as > div').removeClass('active');
                $('#producers-list-menu .show-as > div:eq(0)').addClass('active');

                self.timeline.call(function() {
                    producerListsFilter = {};
                    populateProducerLists();
                    populateFilterLists();
                    $('#producers-list-menu .filter').removeClass('active');
                    $('#producers-list-menu .filter').removeClass('filtered');
                });

                self.timeline.set('#producers-list-menu .filter-menu', { opacity: 0, display: 'none' });

                self.timeline.set('#producers-list-labels', { display: 'block', opacity: 1, position: 'static' });
                self.timeline.set('#producers-list-text', { display: 'none' });

                self.timeline.set('#producers-aside-details .quote', { display: 'none' });

                self.timeline.set('#producers', { display: 'block', opacity: 0 });

                if (producerId !== 'producers') {
                    self.timeline.set('#producers-aside', { display: 'none', opacity: 0 });
                    self.timeline.set('#producers-aside-details', { display: 'block', opacity: 0, x: -344 });
                } else {
                    self.timeline.set('#producers-aside', { display: 'block', opacity: 0, x: -344 });
                    self.timeline.set('#producers-aside-details', { display: 'none', opacity: 0 });
                }

                self.timeline.call(function() { $('body').addClass('alt'); });

                self.timeline.call(this.handleWindowResize.bind(this));
                self.timeline.call(function() { $('html, body').scrollTop(0); });

                self.timeline.to('#producers', 0.5, { opacity: 1 });

                if (producerId !== 'producers') {
                    self.timeline.to('#producers-aside-details', 0.5, { opacity: 1, x: 0 }, '-=0.5');
                } else {
                    self.timeline.to('#producers-aside', 0.5, { opacity: 1, x: 0 }, '-=0.5');
                }

                $('#producers-list-labels a').removeClass('active');
                if (producerId !== 'producers') {
                    setProducer(producerId);
                    setTimeout(function() {
                        $('#producers-list-labels a[router-href="' + producerId + '"]').addClass('active');

                        if ($('#producers-list-menu .show-as > div:eq(0)').hasClass('active')) {
                            $('html, body').animate({
                                scrollTop: $('#producers-list-labels a[router-href="' + producerId + '"]').offset().top - 100
                            }, 250);
                        }
                    });
                }

                    
             
                
                self.timeline.call(function(){
                     
                });
                
                currentProducerId = producerId;

                $('body').on('click', self.hideFilterMenu);
            };

            Producers.prototype.swap = function(producerId) {
                
                
                if (producerId === 'producers') {
                    self.timeline.set('#producers-aside', { display: 'block', opacity: 0 });
                    self.timeline.to('#producers-aside', 0.5, { opacity: 1 });
                    self.timeline.to('#producers-aside-details', 0.5, { display: 'none', opacity: 0 }, '-=0.5');

                    $('html, body').animate({
                        scrollTop: 0
                    }, 250);
                } else if (currentProducerId === 'producers') {
                    setProducer(producerId);
                    self.timeline.set('#producers-aside-details', { display: 'block', opacity: 0 });
                    self.timeline.set('#producers-aside-details .quote', { display: 'none' });
                    self.timeline.to('#producers-aside-details', 0.5, { opacity: 1 });
                    self.timeline.to('#producers-aside', 0.5, { display: 'none', opacity: 0 }, '-=0.5');
                } else {
                    self.timeline.to('#producers-aside-details', 0.5, { opacity: 0 });
                    self.timeline.set('#producers-aside-details .quote', { display: 'none' });
                    self.timeline.call(function() { setProducer(producerId); });
                    self.timeline.to('#producers-aside-details', 0.5, { opacity: 1 });
                }

                $('#producers-list-labels a').removeClass('active');
                if (producerId !== 'producers') {
                    setTimeout(function() {
                        $('#producers-list-labels a[router-href="' + producerId + '"]').addClass('active');

                        if ($('#producers-list-menu .show-as > div:eq(0)').hasClass('active')) {
                            $('html, body').animate({
                                scrollTop: $('#producers-list-labels a[router-href="' + producerId + '"]').offset().top - 100
                            }, 250);
                        }
                    });
                }

                currentProducerId = producerId;
            };


            Producers.prototype.leave = function(callback) {
                self.timeline.call(function() {
                    TweenMax.killChildTweensOf('#producers');
                });

                self.timeline.call(function() { $('body').removeClass('alt'); });
                self.timeline.to('#producers', 0.5, { display: 'none', opacity: 0 });
                self.timeline.to('#producers-aside', 0.5, { display: 'none', opacity: 0 }, '-=0.5');
                self.timeline.to('#producers-aside-details', 0.5, { display: 'none', opacity: 0 }, '-=0.5');

                currentProducerId = undefined;

                if (callback) self.timeline.call(callback);

                $('body').off('click', self.hideFilterMenu);
            };

            Producers.prototype.handleWindowResize = function() {
                $('#producers-list-vineyard-menu').css('left', $('#producers-list-menu .filter:eq(0)').position().left);
                $('#producers-list-area-menu').css('left', $('#producers-list-menu .filter:eq(1)').position().left);
                $('#producers-list-village-menu').css('left', $('#producers-list-menu .filter:eq(2)').position().left);
            };

            Producers.prototype.swapListStyle = function() {
                $('#producers-list-menu .show-as > div').toggleClass('active');

                if ($('#producers-list-menu .show-as > div:eq(0)').hasClass('active')) {
                    self.timeline.set('#producers-list-text', { position: 'absolute' });
                    self.timeline.fromTo('#producers-list-labels', 0.5, { display: 'block', opacity: 0 }, { opacity: 1 });
                    self.timeline.to('#producers-list-text', 0.5, { opacity: 0, display: 'none' }, '-=0.5');
                } else {
                    self.timeline.set('#producers-list-labels', { position: 'absolute' });
                    self.timeline.fromTo('#producers-list-text', 0.5, { display: 'block', opacity: 0 }, { opacity: 1 });
                    self.timeline.to('#producers-list-labels', 0.5, { opacity: 0, display: 'none' }, '-=0.5');
                }
            };

            Producers.prototype.showQuote = function() {
                self.timeline.set('#producers-aside-details .quote', { display: 'block', opacity: 1, y: $('#producers-aside-details .quote').innerHeight() });
                self.timeline.to('#producers-aside-details .quote', 0.5, { display: 'block', opacity: 1, y: 0 });
            };

            Producers.prototype.hideQuote = function() {
                self.timeline.to('#producers-aside-details .quote', 0.5, { display: 'none', opacity: 1, y: $('#producers-aside-details .quote').innerHeight() });
            };

            Producers.prototype.toggleFilter = function(event, type) {
                if (event) event.stopPropagation();

                var filter = '#producers-list-' + type + '-filter';
                var menu = '#producers-list-' + type + '-menu';

                if ($(filter).hasClass('filtered')) {
                    delete producerListsFilter[type];
                    if(type == 'area'){
                        self.closeAllByArea();
                    } 
                    if(type == 'vineyard'){
                        self.closeAllByVineyard();
                    }
                    
                    populateProducerLists();
                    $(filter).removeClass('filtered');

                    $('html, body').animate({
                        scrollTop: 0
                    }, 250);
                } else if ($(menu).css('display') !== 'block') {
                    $('#producers-list-menu .filter').removeClass('active');
                    $(filter).addClass('active');

                    TweenMax.to($('#producers-list-menu .filter-menu').not(menu), 0.5, { opacity: 0, display: 'none' });
                    TweenMax.set(menu, { opacity: 0, display: 'block' });
                    TweenMax.to(menu, 0.5, { opacity: 1 });
                } else self.hideFilterMenu();
            }
            
            Producers.prototype.closeAllByVineyard = function(){
                delete producerListsFilter['area'];
                delete producerListsFilter['village'];
                $('#producers-list-area-menu ul').empty();
                $('#producers-list-village-menu ul').empty();
                $('#producers-list-area-filter').removeClass('filtered');
                $('#producers-list-village-filter').removeClass('filtered');
            }
            
            Producers.prototype.closeAllByArea = function(){
                
                delete producerListsFilter['village'];
                $('#producers-list-village-menu ul').empty();
                $('#producers-list-village-filter').removeClass('filtered');
            }

            Producers.prototype.hideFilterMenu = function() {
                $('#producers-list-menu .filter').removeClass('active');
                TweenMax.to($('#producers-list-menu .filter-menu'), 0.5, { opacity: 0, display: 'none' });
            }

            Producers.prototype.setFilter = function(type, tid, parent_tid, name) {
                self.hideFilterMenu();
                var filter = '#producers-list-' + type + '-filter';
                $(filter).addClass('filtered');
                $('span:nth-of-type(2)', filter).text(name);

                $('html, body').animate({
                    scrollTop: 0
                }, 250);
                
                switch(type){
                    case "vineyard":
                            populateAreaFilter(_.parseInt(tid));
                        break;
                        
                    case "area":
                        populateVillageFilter(_.parseInt(tid));
                        break;
                    case "village":
                        
                        break;
                }
                
                
                producerListsFilter[type] = name;
                populateProducerLists();
            }
            
            var populateAreaFilter = function(vineyardId){
               
                $('#producers-list-area-menu ul').empty();
                var areas = _.chain(app.geographyData).filter( {"parent_tid": vineyardId}).sortBy("name").sortedUniq().value();
                _.forEach(areas, function (area) {
                        $('#producers-list-area-menu ul').append('<li><a router-href="producers" onclick="app.controllers.producers.setFilter(\'area\', \'' + area.tid + '\', \'' + area.parent_tid + '\', \'' + area.name + '\')">' + area.name + '</a></li>');
                    });
                    
                    //self.router.reparseAnchors();
            }
            
            var populateVillageFilter = function(villageId){
                $('#producers-list-village-menu ul').empty();
                var villages = _.chain(app.geographyData).filter( {"parent_tid": villageId}).sortBy("name").sortedUniq().value();
                _.forEach(villages, function (village) {
                        $('#producers-list-village-menu ul').append('<li><a router-href="producers" onclick="app.controllers.producers.setFilter(\'village\', \'' + village.tid + '\', \'' + village.parent_tid + '\', \'' + village.name + '\')">' + village.name + '</a></li>');
                    });
                    
                    //self.router.reparseAnchors();
            }

            var setProducer = function(producerId) {
                var producer = _.find(self.producersData, { translationNid: producerId });
                $('#producers-aside-details .details h3').html(producer.htmlName);
                $('#producers-aside-details .details p').html(producer.description);
                if(producer.quote != ""){
                    $('#producers-aside-details .details button').show();
                    $('#producers-aside-details .quote p').html(producer.quote);
                }else{
                     $('#producers-aside-details .details button').hide();
                }
                
                //$('#producers-aside-details .background').css('background-image', 'url("' + (rootPath || '') + producer.image + '")');
                $('#producers-aside-details .background').css('background-image', 'url("'+ producer.image + '")');
            };

            var populateProducerLists = function() {
                
                $('#producers-list-labels').empty();
                $('#producers-list-text').empty();
                
                var filteredProducers = _.filter(self.producersData, producerListsFilter);
                
                var letters = _.chain(filteredProducers).map('letter').sortBy().sortedUniq().value();
                
                _.forEach(letters, function(letter) {
                    $('#producers-list-labels').append('<div class="letter">' + letter + '</div>');

                    $('#producers-list-text').append('<div class="letter">' + letter + '</div>');
                    var listTextHtml = '<ul>';

                    var producers = _.chain(filteredProducers).filter({ letter: letter }).sortBy('name').value();
                    _.forEach(producers, function(producer) {
                        // Add producer to label list
                        
                        
                        $('#producers-list-labels').append(
                            /*'<a class="producer" router-href="' + producer.id + '">' +*/
                            '<a class="producer" router-href="' + producer.translationNid + '">' +
                            '<div class="background-contain fullscreen lazyload" data-bg="' + (rootPath || '') + 'assets/vignerons/survol_etiquette.png"></div>' +
                            '<div class="relative">' +
                            '<img data-src="' + producer.label + '" class="lazyload">' +
                            '<hr>' +
                            '<p>' + producer.htmlName + '</p>' +
                            '</div>' +
                            '</a>');
                            
                        // Add producer to text list
                        //listTextHtml += '<li><a class="producer" router-href="' + producer.id + '">' + producer.htmlName + '</a></li>';
                        listTextHtml += '<li><a class="producer" router-href="' + producer.translationNid + '">' + producer.htmlName + '</a></li>';
                    });

                    listTextHtml += '</ul>';
                    $('#producers-list-text').append(listTextHtml);
                    
                });
                
                  _.forEach($('#producers-list-labels img'), function(element){
                      //console.log(element);
                    $(element).on('load',function(){
                        
                        var elementHeight = $(this).height()
                        
                        if(elementHeight > 110 && elementHeight < 160) $(this).addClass("reduce"); 
                        else if(elementHeight >= 160) $(this).addClass("reduce2");
                    });
                })
                
              self.router.reparseAnchors();
                
            }

            var populateFilterLists = function() {
                
                $('#producers-list-vineyard-menu ul').empty();
                $('#producers-list-area-menu ul').empty();
                $('#producers-list-village-menu ul').empty();
                
                var vineyards = _.chain(app.geographyData).filter({"parent_tid": 0}).sortBy("name").sortedUniq().value();    
                _.forEach(vineyards, function (vineyard) {

                    $('#producers-list-vineyard-menu ul').append('<li><a router-href="producers" onclick="app.controllers.producers.setFilter(\'vineyard\', \'' + _.parseInt(vineyard.tid) + '\', \'' + _.parseInt(vineyard.parent_tid) + '\', \'' + vineyard.name + '\')">' + vineyard.name + '</a></li>');
                });
                
                
                /*$('#producers-list-vineyard-menu ul').empty();
                var vineyards = _.chain(self.producerData).map('vineyard').sortBy().sortedUniq().value();
                _.forEach(vineyards, function(vineyard) {
                    $('#producers-list-vineyard-menu ul').append('<li><a router-href="producers" onclick="app.controllers.producers.setFilter(\'vineyard\', \'' + vineyard + '\')">' + vineyard + '</a></li>');
                });*/

                
                var villages = _.chain(self.producerData).map('village').sortBy().sortedUniq().value();
                _.forEach(villages, function(village) {
                    $('#producers-list-village-menu ul').append('<li><a router-href="producers" onclick="app.controllers.producers.setFilter(\'village\', \'' + village + '\')">' + village + '</a></li>');
                });

                //self.router.reparseAnchors();
            }

            return Producers;
        })();

        Controllers.Producers = Producers;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));